export const HOT_TUB_SORT_OPTION = 'hot-tub-sort-option';
export const HOT_TUB_VENDOR_OPTION = 'hot-tub-vendor-option';
export const HOT_TUB_CATEGORY_OPTION = 'hot-tub-category-option';
export const POOL_SORT_OPTION = 'pool-sort-option';
export const POOL_VENDOR_OPTION = 'pool-vendor-option';
export const POOL_CATEGORY_OPTION = 'pool-category-option';
export const CUSTOMER_TOKEN = 'customer-token';
export const CART_ID = 'cartId';
export const CHECKOUT_ID = 'checkoutId';